import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { OperationDetailsPage } from './operation-details';
import { RemoveCommentComponent } from '../remove-comment/remove-comment.component';
import { SharedModule } from '../../shared/shared.module';
import { TextMaskModule } from 'angular2-text-mask';
import { FoundationModule } from '../../../_foundation/foundation.module';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    OperationDetailsPage,
    RemoveCommentComponent,
  ],
  imports: [
    IonicPageModule.forChild(OperationDetailsPage),
    IonicPageModule.forChild(RemoveCommentComponent),
    SharedModule,
    TextMaskModule,
    FoundationModule,
    DirectivesModule,
  ],
  providers: []
})
export class OperationDetailsPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/operations/operation-details/operation-details.module.ts